import { render, staticRenderFns } from "./InvoiceDownload.vue?vue&type=template&id=2ddc8556&"
import script from "./InvoiceDownload.vue?vue&type=script&lang=js&"
export * from "./InvoiceDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports